"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    text-decoration: ", ";\n    font-weight: ", ";\n"], ["\n    color: ", ";\n    text-decoration: ", ";\n    font-weight: ", ";\n"]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require("react-router-dom");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledLink = (0, _styledComponents2.default)(_reactRouterDom.Link)(_templateObject, function (props) {
    return props.color ? props.theme.link.colors[props.color] : "inherit";
}, function (props) {
    return props.theme.link.textDecoration;
}, function (props) {
    return props.theme.link.fontWeight;
});

StyledLink.displayName = "StyledLink";

StyledLink.propTypes = {
    color: _propTypes2.default.string
};

exports.default = StyledLink;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/styledLink.js
// module id = 1018
// module chunks = 95715928098905 168707334958949